import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";
import { subtotal } from "./tableColumns";
import { confirmationGroupKey, confirmationLineDisplayName } from "../../../service/confirmationEditorView";
import type { FulfillmentOrderLine } from "../../../types";

/** 独立维护飞机路线、角色和路线小计的表格展示。 */
export function ConfirmationAirTable({ common, table, mode = "air" }: ConfirmationCategoryTableProps & { mode?: "air" | "ship" }) {
  const { item, role, quantity, count, price, amount, provider, tail } = common;
  const groupKey = (line: FulfillmentOrderLine) => confirmationGroupKey(line, mode);
  const columns: ConfirmationTableColumn[] = [
    { ...item, label: "路线", width: 172, render: line => common.itemTitle(line, confirmationLineDisplayName(line)) },
    { ...role, width: 78 }, quantity("人数"), count("次数"),
    price, amount, subtotal("路线小计 / 差异", groupKey), provider, ...tail,
  ];
  return <ConfirmationLineTable {...table} columns={columns} variant="air" />;
}
